import axiosInstance from "utils/axiosInstance";
import { WarningNetworkFailure } from "helpers/alertsweet";

const BASE_URL = (
  process.env.REACT_APP_MAIN_API_URL ||
  process.env.REACT_APP_BASE_API_URL ||
  ""
).replace(/\/$/, "");

const DONATE_URL = `${BASE_URL}/donate`;

const getAuthHeaders = (token: string, businessId?: string) => ({
  authorization: "Bearer " + token,
  ...(businessId ? { b: businessId } : {}),
});

const getQueryParams = (params: Record<string, any> = {}) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    queryParams.set(key, String(value));
  });

  return queryParams.toString();
};

export type DonateWithdrawCreateOnePayload = {
  amount: number;
  message?: string;
};

const normalizeDonateWithdrawCreateOnePayload = (
  input: DonateWithdrawCreateOnePayload,
): DonateWithdrawCreateOnePayload => {
  const amount = Number(input.amount);

  const message = input.message ? String(input.message).trim() : undefined;

  return {
    amount,
    message: message || undefined,
  };
};

export const donateWithdrawCreateOne = async ({
  body,
  token,
  businessId,
}: {
  body: DonateWithdrawCreateOnePayload;
  token: string;
  businessId?: string;
}): Promise<any> => {
  try {
    const url = `${DONATE_URL}/withdraw/create-one`;
    const normalized = normalizeDonateWithdrawCreateOnePayload(body);
    const res = await axiosInstance.post(url, normalized, {
      headers: getAuthHeaders(token, businessId),
    });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") WarningNetworkFailure();
    console.error("donateWithdrawCreateOne error", error);
    throw error;
  }
};

export const donateWithdrawGetMany = async ({
  findby = {},
  token,
  businessId,
  skip,
  limit,
}: {
  findby?: Record<string, any>;
  token: string;
  businessId?: string;
  skip?: number;
  limit?: number;
}): Promise<any> => {
  try {
    const queryParams = getQueryParams({
      ...findby,
      skip,
      limit,
    });
    const url = `${DONATE_URL}/withdraw/get-many${
      queryParams ? `?${queryParams}` : ""
    }`;
    const res = await axiosInstance.get(url, {
      headers: getAuthHeaders(token, businessId),
    });
    return res.data;
  } catch (error: any) {
    if (error.message === "Network Error") WarningNetworkFailure();
    console.error("donateWithdrawGetMany error", error);
    throw error;
  }
};
